<div class="wrapper">
  <div class="description text-type-10">{{ data?.title }}</div>
  <div class="site-details flex flex-row justify-start items-center">
    <div class="label uppercase text-type-13">
      Site:
    </div>
    <div class="site text-type-14 description-text mb-[2px] ml-[5px]">{{ data?.site?.name }}</div>
  </div>
</div>
